// extracted by mini-css-extract-plugin
export default {"form":"EditarDistribuidor_form__H1qfQ","areaBtn":"EditarDistribuidor_areaBtn__m+Eug","btn":"EditarDistribuidor_btn__Ma6UQ"};